import styled from '@emotion/styled'

export const StyleBannerWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.inputBorder};
  height: 300px;
  border-radius: 8px;
`
export const StyleBannerGrid = styled.div`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(3, 1fr);
  margin-top: -50px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
export const StyleBannerGridItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`
export const StyleCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  padding: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 100%;
`
